<template>
  <div class="main">
    <c-panel>
      <conformidade :paramInstituicaoId="$route.params.instituicao_id" :paramData="$route.params.data"></conformidade>
    </c-panel>
  </div>
</template>
<script>
import conformidade from "./conformidade"

export default {
  components: { conformidade }
}
</script>
